import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.drawing.add');
import { OnInit, Input, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-drawing-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.drawing.add/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectDrawingAddComponent implements OnInit {
    @Input() isOpen: boolean = false;
    @Input() projectId: string = '';
    @Output() onClose = new EventEmitter<void>();
    @Output() onUploaded = new EventEmitter<void>();

    public files: File[] = [];
    public isUploading: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() { }

    public close() {
        this.files = [];
        this.onClose.emit();
    }

    public onFileChange(event: any) {
        const fileList = event.target.files;
        if (!fileList || fileList.length === 0) return;
        
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const identity = file.type.split('/')[0];
            const isPDF = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
            if (identity !== 'image' && !isPDF) continue;
            this.files.push(file);
        }
        this.ref.detectChanges();
    }

    public removeFile(index: number) {
        this.files.splice(index, 1);
        this.ref.detectChanges();
    }

    public formatFileSize(bytes: number): string {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public async upload() {
        if (this.files.length === 0) return;

        this.isUploading = true;
        await this.service.loading.show();

        const fd = new FormData();
        fd.append('project_id', this.projectId);
        for (const file of this.files) {
            fd.append('file[]', file);
        }

        try {
            const res = await fetch(wiz.url('upload_drawings'), {
                method: 'POST',
                body: fd,
                credentials: 'include'
            });
            const result = await res.json();

            if (res.status === 200) {
                this.files = [];
                this.isUploading = false;
                await this.service.loading.hide();
                await this.service.alert.show({
                    title: '성공',
                    message: '도면이 업로드되었습니다.',
                    status: 'success',
                    action: '확인',
                    cancel: false
                });
                this.onUploaded.emit();
                this.onClose.emit();
                return;
            } else {
                throw new Error(result.message || result.data || '업로드 실패');
            }
        } catch (e: any) {
            this.isUploading = false;
            await this.service.loading.hide();
            await this.service.alert.show({
                title: '오류',
                message: e.message || '업로드에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }
        this.ref.detectChanges();
    }
}

export default ComponentProjectDrawingAddComponent;